import React from 'react';
import classnames from 'classnames';
import { AvatarIcon as Avatar } from '@lt/components';

import { formatDateToDayShortWithYear } from 'src/utils/dateUtils';

import type { ReviewsProps } from '@lt/api/dist/methods/hotelReviews/types';
import { letterDescriptionRating } from '../../utils/utils';

import styles from './swipeReviewCard.module.css';

// import GallerySwiperReviewCard from '../GallerySwiperReviewCard/GallerySwiperReviewCard';

const SwipeReviewsCard = (
  props: Pick<
    ReviewsProps,
    | 'content'
    | 'name'
    | 'createdAt'
    | 'averageRating'
    | 'avatarUrl'
    | 'images'
    | 'title'
  > & { className?: string },
) => {
  const {
    content,
    name,
    createdAt,
    averageRating,
    avatarUrl,
    // images,
    title,
    className,
  } = props;

  const reviewDate = formatDateToDayShortWithYear(createdAt);
  const rating = letterDescriptionRating(averageRating);

  return (
    <div className={classnames(styles.reviewItem, className)}>
      <div className={styles.container}>
        <div
          className={styles.ratingReview}
          style={{ backgroundColor: rating.styleString }}
        >
          {rating.text}
        </div>
        <div className={styles.ratingDate}>{reviewDate}</div>
      </div>
      <div className={styles.container}>
        <div>
          <Avatar
            className={styles.imageComponent}
            avatarUrl={avatarUrl}
            size={40}
            name={name}
          />
        </div>
        <div className={styles.header}>
          <div className={styles.name}>{name}</div>
          <div className={styles.title}>{title}</div>
        </div>
      </div>
      {/* Не показываем фотки, пока не запустим новые отзывы на странице отзывов
        {images.length > 0 && (
        <GallerySwiperReviewCard
          title={`ReviewCard-${name}`}
          images={images}
          isMobile
          className={styles.containerGallery}
          disableOpenGallery
        />
      )} */}
      <div
        style={{ '--line': 7 } as React.CSSProperties} // пока нет изображений всегда показываем 7 строк
        className={styles.content}
      >
        {content}
      </div>
    </div>
  );
};

export default SwipeReviewsCard;
